import { AxiosError } from 'axios'
import { useQuery, UseQueryOptions } from 'react-query'
import { components } from '@plandi/common/src/generated'
import { removeEmptyFieldObject, useLocale } from '@plandi/common'

import { projectKeys } from '../projects.constants'
import { projectsApi } from '../projects.api'
import { QueryParamsGetMeProjects } from '../projects.types'

export const useQueryProjectsMe = <
  T = components['schemas']['ProjectMarketMeResource'][] | undefined
>(
  params?: QueryParamsGetMeProjects,
  type?: string,
  options?: UseQueryOptions<
    components['schemas']['ProjectMarketMeResource'][] | undefined,
    AxiosError,
    T
  >
) => {
  const paramsOptions = removeEmptyFieldObject(params ?? {})
  const locale = useLocale()

  const data = useQuery(
    [projectKeys.listMe(paramsOptions), type, locale],
    () => projectsApi.getProjectsMe(locale, paramsOptions, type),
    options
  )

  return data
}
